// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__AOfHt","header":"PatientQuestionnaire_header__nxkEE","info":"PatientQuestionnaire_info__34d7H"};